export default {
  SET_USERS_LIST(state, data) {
    state.users = data
  },
  SET_ONE_USER(state, data) {
    state.single_user = data
  },
  SET_ROLES(state, data) {
    state.roles = data
  },
  SET_USER_PERMISSIONS(state, data) {
    state.permissions = data
  },
}
